import { Form, Formik } from "formik";
import Select from "react-select";
import {
  APPLY_BUTTON_STYLE,
  RESET_BUTTON_STYLE,
  getTodayEndDateTime,
} from "./reportCommon";
import { DEFAULT_IEC_ACTIVITY_FILTERS } from "./staticReportData";

const FUTURE_DATE_ERROR = "Future date/time is not allowed";

const validateDateRange = (values) => {
  const errors = {};
  const now = new Date();

  if (values.fromDateTime && new Date(values.fromDateTime) > now) {
    errors.fromDateTime = FUTURE_DATE_ERROR;
  }
  if (values.toDateTime && new Date(values.toDateTime) > now) {
    errors.toDateTime = FUTURE_DATE_ERROR;
  }

  return errors;
};

const IecActivityFilter = ({
  initialValues = DEFAULT_IEC_ACTIVITY_FILTERS,
  wardOptions = [],
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    validate={validateDateRange}
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, errors, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-2 mb-3">
            <label className="form-label">Ward</label>
            <Select
              inputId="wardId"
              name="wardId"
              classNamePrefix="react-select"
              options={wardOptions.map((ward) => ({
                value: String(ward.wardId),
                label: ward.wardName,
              }))}
              value={
                wardOptions
                  .map((ward) => ({
                    value: String(ward.wardId),
                    label: ward.wardName,
                  }))
                  .find((option) => option.value === String(values.wardId)) ||
                null
              }
              onChange={(selected) =>
                setFieldValue("wardId", selected ? selected.value : "")
              }
              placeholder="Select Ward"
              isClearable
              menuPlacement="auto"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-2 mb-3">
            <label className="form-label">From Date &amp; Time</label>
            <input
              type="datetime-local"
              name="fromDateTime"
              value={values.fromDateTime}
              max={getTodayEndDateTime()}
              onChange={(event) =>
                setFieldValue("fromDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
            {errors.fromDateTime && (
              <div className="text-danger small mt-1">
                {errors.fromDateTime}
              </div>
            )}
          </div>

          <div className="col-md-2 mb-3">
            <label className="form-label">To Date &amp; Time</label>
            <input
              type="datetime-local"
              name="toDateTime"
              value={values.toDateTime}
              min={values.fromDateTime || undefined}
              max={getTodayEndDateTime()}
              onChange={(event) =>
                setFieldValue("toDateTime", event.target.value)
              }
              className="form-control bg-white"
            />
            {errors.toDateTime && (
              <div className="text-danger small mt-1">
                {errors.toDateTime}
              </div>
            )}
          </div>

          <div className="col-md-3 mb-3 d-flex gap-2">
            <button type="submit" style={APPLY_BUTTON_STYLE}>
              APPLY FILTERS
            </button>
            <button
              type="button"
              style={RESET_BUTTON_STYLE}
              onClick={() => {
                resetForm({ values: DEFAULT_IEC_ACTIVITY_FILTERS });
                onReset?.();
              }}
            >
              RESET
            </button>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

export default IecActivityFilter;
